import { createIcon } from '@chakra-ui/react';

export const EditPenIcon = createIcon({
  displayName: 'EditPenIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '6',
    width: '6',
  },
  path: (
    <path
      d="M16.7622 3.17651C17.4455 2.49332 18.5534 2.49356 19.2368 3.17651L20.8228 4.76245C21.5061 5.44585 21.5061 6.55366 20.8228 7.23706L8.67529 19.3845C8.50773 19.5521 8.30742 19.6842 8.0874 19.7722L4.36084 21.2625C3.34071 21.67 2.32899 20.6586 2.73682 19.6384L4.22705 15.9119C4.31506 15.6919 4.44722 15.4915 4.61475 15.324L16.7622 3.17651ZM5.67529 16.3845C5.65149 16.4083 5.63219 16.4373 5.61963 16.4685L4.34521 19.6531L7.53076 18.3796C7.56204 18.3671 7.5909 18.3478 7.61475 18.324L16.939 8.99976L14.9995 7.0603L5.67529 16.3845ZM18.1763 4.23706C18.0786 4.13989 17.9202 4.13965 17.8228 4.23706L16.0601 5.99976L17.9995 7.93921L19.7622 6.17651C19.8597 6.0789 19.8597 5.92061 19.7622 5.823L18.1763 4.23706Z"
      fill="currentColor"
    />
  ),
});
